import React from "react";

import { hero } from "../data";

import Stats from "./Stats";

const Hero = () => {
  const { title } = hero;
  return (
    <section
      className="h-[850px] w-full bg-hero bg-center bg-cover bg-no-repeat text-white pt-[225px] pb-[254px] relative mb-2 lg:mb-28"
      id="home"
    >
      <div className="container  mx-auto text-center">
        <h1 className="text-2xl mx-auto font-semibold mb-[430px] lg:mb-[480px] lg:text-[38px] lg:leading-tight lg:max-w-[888px]">
          {title}
        </h1>
        <div>
          <Stats />
        </div>
      </div>
    </section>
  );
};

export default Hero;
